/* loaded by smart-asset */
export default require("./facebook~WbHeMmNj.png")